/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Icon from '@mui/material/Icon'

// Material Dashboard 2 React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDAvatar from 'components/MDAvatar'
import MDProgress from 'components/MDProgress'

// Images
import LogoAsana from 'assets/images/small-logos/logo-asana.svg'
import logoGithub from 'assets/images/small-logos/github.svg'
import logoAtlassian from 'assets/images/small-logos/logo-atlassian.svg'
import logoSlack from 'assets/images/small-logos/logo-slack.svg'
import logoSpotify from 'assets/images/small-logos/logo-spotify.svg'
import logoInvesion from 'assets/images/small-logos/logo-invision.svg'
import { useAppServices } from 'hook/services'
import { useState, useEffect } from 'react'
import MDButton from 'components/MDButton'
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import MoveDoc from '../docs/MoveDoc'

export default function data() {
  const { state } = useLocation()
  const AppService = useAppServices()
  const Navigate = useNavigate()
  const [loader, setLoader] = useState(true)
  const [docs, setDocs] = useState([])
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])

  const handleDeleteCategory = async (id, idx) => {
    Swal.fire({
      title: 'Warning',
      text: 'Are you sure you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Yes',
    }).then(async (res) => {
      if (!res.isConfirmed) return
      const { response } = await AppService.location_docs.delete({
        query: `_id=${id}`,
        toaster: true,
      })
      if (response) {
        docs.splice(idx, 1)
        setDocs([...docs])
      }
    })
  }
  const getDocs = async () => {
    const { response } = await AppService.location_docs.doc_move_data({
      query: `type=super-admin&category=${state.category}&sub_category=${state._id}`,
    })
    if (response) {
      setDocs(response.data)
      setCategories(
        response.categories.map((item) => ({
          label: item.name,
          value: item._id,
        }))
      )
      setSubCategories(
        response.sub_categories.map((item) => ({
          label: item.name,
          value: item._id,
          category: item.category,
        }))
      )
      setLoader(false)
    } else {
      setLoader(false)
    }
  }
  const onLoad = () => {
    // console.log(state, 'state')
    getDocs()
  }
  useEffect(onLoad, [])

  const HandleUpdate = (item) => {
    Navigate('./update', { state: { doc: item, SubCategory: state } })
  }

  return {
    loader: loader,
    columns: [
      { Header: 'title', accessor: 'title', width: '30%', align: 'left' },
      { Header: 'version', accessor: 'version', width: '30%', align: 'left' },
      { Header: 'action', accessor: 'action', align: 'center' },
    ],

    rows: docs.map((item, idx) => ({
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {' '}
          {item.title}{' '}
        </MDTypography>
      ),
      version: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.version || '1.0'}
        </MDTypography>
      ),

      action: (
        <>
          <MDButton
            onClick={() => HandleUpdate(item)}
            variant="gradient"
            color="primary"
            style={{ marginRight: '10px' }}
          >
            Edit{' '}
          </MDButton>
          <MDButton
            variant="gradient"
            color="primary"
            onClick={() => handleDeleteCategory(item._id, idx)}
          >
            Delete{' '}
          </MDButton>
          <MoveDoc
            data={item}
            categories={categories}
            subCategories={subCategories}
            handleRefresh={getDocs}
          />
        </>
      ),
    })),
  }
}
